import * as Schedules from '../../schedules'

export interface SkinnySchedule {
  id: number,
  name: string,
}

export const getSchedule = (schedules: Schedules.ScheduleState, scheduleId: number): SkinnySchedule => {
  const filtered = schedules.filter((s: Schedules.Schedule) => s.id === scheduleId)
  return filtered && filtered.length > 0 ? filtered[0] : {id: 0, name: '<none>'}
}



// WEBPACK FOOTER //
// ./src/pages/members/details/utils.ts